import { __assign } from "tslib";
import ddt from '@wix/da-ddt';
import { useIsCurrentUserDeviationAuthor } from '../../../utils/hooks/useIsCurrentUserDeviationAuthor';
var logger = ddt.createLogger('downloadbutton');
export var FREE_DOWNLOAD_PERMISSIONS = {
    DOWNLOADABLE: 'downloadable',
    NEEDS_SUBSCRIPTION: 'needs_subscription',
    BLOCKED_BY_SUBSCRIPTION: 'blocked_by_subscription',
};
export function getDeviationFreeDownload(deviation) {
    var _a;
    var freeDownload = (_a = deviation.extended) === null || _a === void 0 ? void 0 : _a.download;
    logger.log('free download', freeDownload);
    if (!freeDownload) {
        return {};
    }
    // the only thing preventing a free download is a subscription
    var tierAccess = deviation.tierAccess;
    var permission = 'downloadable';
    if (tierAccess === 'locked') {
        permission = FREE_DOWNLOAD_PERMISSIONS.NEEDS_SUBSCRIPTION;
    }
    if (tierAccess === 'locked-subscribed') {
        permission = FREE_DOWNLOAD_PERMISSIONS.BLOCKED_BY_SUBSCRIPTION;
    }
    logger.log('free download', { tierAccess: tierAccess, permission: permission });
    return { download: freeDownload, permission: permission };
}
export var PREMIUM_DOWNLOAD_PERMISSIONS = {
    DOWNLOADABLE: 'downloadable',
    PURCHASABLE: 'purchasable',
};
export function getDeviationPremiumDownload(deviation, isOwner) {
    var _a;
    var premiumDownload = (_a = deviation.extended) === null || _a === void 0 ? void 0 : _a.pcp;
    logger.log('premium download', premiumDownload);
    if (!premiumDownload) {
        return {};
    }
    // purchasing, unblocked subscriptions, and ownership
    // give access to premium downloads
    var purchasedSeparately = premiumDownload === null || premiumDownload === void 0 ? void 0 : premiumDownload.hasUserPurchased;
    var tierAccess = deviation.tierAccess;
    var hasSubscriptionAccess = tierAccess === 'unlocked';
    var hasPremiumAccess = purchasedSeparately || hasSubscriptionAccess || isOwner;
    var permission = hasPremiumAccess
        ? PREMIUM_DOWNLOAD_PERMISSIONS.DOWNLOADABLE
        : PREMIUM_DOWNLOAD_PERMISSIONS.PURCHASABLE;
    logger.log('premium download', {
        isOwner: isOwner,
        purchasedSeparately: purchasedSeparately,
        tierAccess: tierAccess,
        permission: permission,
    });
    return { download: premiumDownload, permission: permission };
}
export function getDeviationDownloads(_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var _b = getDeviationFreeDownload(deviation), freeDownload = _b.download, freeDownloadPermission = _b.permission;
    var _c = getDeviationPremiumDownload(deviation, isOwner), premiumDownload = _c.download, premiumDownloadPermission = _c.permission;
    return __assign(__assign({}, (freeDownload && { freeDownload: freeDownload, freeDownloadPermission: freeDownloadPermission })), (premiumDownload && { premiumDownload: premiumDownload, premiumDownloadPermission: premiumDownloadPermission }));
}
export function useDeviationDownloads(deviation) {
    // precondition: the user is logged in
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    return getDeviationDownloads({ deviation: deviation, isOwner: isOwner });
}
//# sourceMappingURL=permissions.js.map